import type { SignalSeverity } from './SignalTypes';

/**
 * Severity → theme color for alert/anomaly indicators. Shared by the signal
 * tile dashboard and the topic-level alert list so both read identically.
 * Keys cover the full {@link SignalSeverity} union; the narrower
 * `AnomalySeverity` (`high | medium | low`) indexes it safely.
 */
export const SEVERITY_COLORS: Record<SignalSeverity, string> = {
    critical: 'var(--bm-color-danger)',
    high: 'var(--bm-color-warning)',
    medium: 'var(--bm-color-caution)',
    low: 'var(--bm-color-success)',
    info: 'var(--bm-color-text-dimmed)',
};
